import { Fragment, Component, createRef } from 'react';
import { withRouter } from 'react-router-dom';
import Image from 'components/Image';
import WithScroll from 'hocs/WithScroll';

class SimpleIntegration extends Component {
  cPanel = createRef();

  whmcs = createRef();

  siteplusApi = createRef();

  plesk = createRef();

  componentDidMount() {
    this.handlePathHash(this.props.location);
  }

  shouldComponentUpdate(newProps) {
    const { hash } = newProps.location;
    if (hash) {
      this.handlePathHash(newProps.location);
      return true;
    }

    return false;
  }

  handlePathHash = ({ hash, pathname }) => {
    if (hash) {
      this.scrollToSection(hash.substring(1));
      this.props.history.replace(pathname);
    }
  };

  scrollToSection(section) {
    this.props.scroll.triggerScrolling(this[section].current.offsetTop, true);
  }

  render() {
    return (
      <Fragment>
        <section className="section section_simple-integration_1">
          <div className="wrapper">
            <div className="row">
              <div className="col col-7 col-tablet-12 section__col">
                <h1 className="title title_size_xl title_white _mb-19 _mt-127 _mt-tablet-0 _mt-quad-153">
                  <span className="title__break">Integrate</span>
                  with Siteplus
                </h1>
                <p className="text text_white text_size_xl section__text">
                  <span className="text__break">
                    Your own website builder connected to
                  </span>{' '}
                  your hosting services.
                </p>
              </div>
              <div className="col col-5">
                <div className="section__image-wrap">
                  <Image className="section__image" src="img-68.png" />
                </div>
              </div>
            </div>
          </div>
        </section>
        <section
          className="section section_simple-integration_4"
          ref={this.siteplusApi}
        >
          <div className="wrapper">
            <div className="section__content-wrap _mb-72">
              <h2 className="title title_size_l _mb-16">
                Custom API integration
              </h2>
              <p className="text section__text">
                <span className="text__break">
                  Siteplus developer API gives you full control over the Website
                  Builder customer functionality.
                </span>{' '}
                Build any custom integration to your existing systems using
                simplified API commands.
              </p>
            </div>
            <div className="_mb-40">
              <Image src="custom-integration.svg" />
            </div>
          </div>
        </section>
        <section
          className="section section_simple-integration_2"
          ref={this.cPanel}
        >
          <div className="wrapper">
            <div className="row">
              <div className="col col-5 col-tablet-12">
                <div className="_mt-107 _mt-laptop-10 _mt-tablet-0 _mb-tablet-60">
                  <h2 className="title title_size_l _mb-16">cPanel plugin</h2>
                  <p className="text _mb-21">
                    A Website Builder for cPanel. This plugin will seamlessly
                    integrate with cPanel and connects with the user Domain Name
                    and Web Hosting storage to publish their website.
                  </p>
                  <ul className="section__list _mb-28">
                    <li className="text section__list-item">
                      Install on unlimited servers
                    </li>
                    <li className="text section__list-item">
                      White label as your brand
                    </li>
                    <li className="text section__list-item">
                      Manage with WHM interface
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col col-6 offset-1 col-tablet-12 offset-tablet-0">
                <div className="section__image-wrap">
                  <Image src="cpanel.svg" />
                </div>
              </div>
            </div>
          </div>
        </section>
        <section
          className="section section_simple-integration_3"
          ref={this.whmcs}
        >
          <div className="wrapper">
            <div className="row row-reverse-tablet">
              <div className="col col-6 col-tablet-12 section__col">
                <div className="section__image-wrap">
                  <Image src="whmcs.svg" />
                </div>
              </div>
              <div className="col col-5 offset-1 col-tablet-12 offset-tablet-0">
                <div className="_mt-102 _mb-tablet-60 _mt-tablet-0">
                  <h2 className="title title_size_l _mb-16">WHMCS plugin</h2>
                  <p className="text _mb-21">
                    Integrate using Siteplus native WHMCS Website Builder
                    plugin. This allows you to maintain the flexibility and
                    control with your current WHMCS environment.
                  </p>
                  <ul className="section__list _mb-28">
                    <li className="text section__list-item">
                      Simple plan management
                    </li>
                    <li className="text section__list-item">
                      White label as your brand
                    </li>
                    <li className="text section__list-item">
                      Pairs with cPanel plugin
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section
          className="section section_simple-integration_2"
          ref={this.plesk}
        >
          <div className="wrapper">
            <div className="row">
              <div className="col col-5 col-tablet-12">
                <div className="_mt-107 _mt-laptop-10 _mt-tablet-0 _mb-tablet-60">
                  <h2 className="title title_size_l _mb-16">Plesk plugin</h2>
                  <p className="text _mb-21">
                    The Siteplus Plesk plugin makes installing Siteplus a
                    breeze. After activating the plugin, Siteplus will connect
                    with the users Domains and Hosting storage for quick
                    publishing.
                  </p>
                  <ul className="section__list _mb-28">
                    <li className="text section__list-item">
                      Install on unlimited servers
                    </li>
                    <li className="text section__list-item">
                      White label as your brand
                    </li>
                    <li className="text section__list-item">
                      Simple customer management
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col col-6 offset-1 col-tablet-12 offset-tablet-0">
                <div className="section__image-wrap">
                  <Image src="plesk.svg" />
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="section section_simple-integration_5">
          <div className="wrapper">
            <h2 className="title section__main-title _mb-61">FAQs</h2>
            <div className="row">
              <div className="col col-6 col-tablet-portrait-12">
                <div className="_mb-62">
                  <h5 className="title title_size_xs_old _mb-8">
                    What kind of API does Siteplus have?
                  </h5>
                  <p className="text">
                    Siteplus offer a REST API that you can automate from your
                    existing systems to set up customer accounts, upgrade,
                    downgrade and manage all statuses and permissions.
                  </p>
                </div>
              </div>
              <div className="col col-6 col-tablet-portrait-12">
                <div className="_mb-62">
                  <h5 className="title title_size_xs_old _mb-8">
                    Do I host the Website Builder software?
                  </h5>
                  <p className="text">
                    The Website Builder application is a managed web service and
                    is hosted within our cloud network under your domain name.
                    We do this to ensure fast updates can be applied and so that
                    your customers get the fastest speeds.
                  </p>
                </div>
              </div>
              <div className="col col-6 col-tablet-portrait-12">
                <div className="_mb-62">
                  <h5 className="title title_size_xs_old _mb-8">
                    Does Siteplus use CDN?
                  </h5>
                  <p className="text">
                    The Siteplus platform is served with Cloudflare to ensure
                    the fastest possible loading speeds globally for your
                    customers.
                  </p>
                </div>
              </div>
              <div className="col col-6 col-tablet-portrait-12">
                <div className="_mb-62">
                  <h5 className="title title_size_xs_old _mb-8">
                    Does Siteplus have DDoS protection?
                  </h5>
                  <p className="text">
                    The Siteplus platform has multiple protection from DDos
                    attacks. This protection is natively built into the
                    platform.
                  </p>
                </div>
              </div>
              <div className="col col-6 col-tablet-portrait-12">
                <div className="_mb-62">
                  <h5 className="title title_size_xs_old _mb-8">
                    Is my customer data private?
                  </h5>
                  <div className="text">
                    Yes, all customer data is yours. We do not approach, market
                    or contact any customers in any way. The internal
                    notifications in the customer Website Builder dashboard are
                    all generic. Rest assured we take your customers' privacy
                    seriously.
                  </div>
                </div>
              </div>
              <div className="col col-6 col-tablet-portrait-12">
                <div className="_mb-62">
                  <h5 className="title title_size_xs_old _mb-8">
                    What are my options for website transfers?
                  </h5>
                  <p className="text">
                    We support website transfers from all major providers. Our
                    set of unique tools will help you expedite the transfer
                    process.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </Fragment>
    );
  }
}

export default WithScroll(withRouter(SimpleIntegration));
